export default "__VITE_ASSET__3_QjIlKo__"